import { jsx as e } from "react/jsx-runtime";
import { forwardRef as h, useMemo as S } from "react";
import { Input as v } from "../../../atoms/Input/Input.container.es.js";
import { Spinner as x, chakra as I } from "@chakra-ui/react";
import { useLocationPickerContext as L } from "../LocationPicker.context.es.js";
import { SearchIcon as k } from "../../../icons/index.es.js";
const w = h((C, n) => {
  const {
    error: i,
    getReferenceProps: a,
    inputProps: s,
    isError: p,
    isLoading: o,
    isSmartData: t,
    isSmartDataLoading: c,
    onInputClear: m,
    onRetry: f,
    query: r,
    refs: u,
    setQuery: d
  } = L(), l = S(() => {
    if (!r.length)
      return /* @__PURE__ */ e(k, { boxSize: 4 });
    if (o)
      return /* @__PURE__ */ e(x, { boxSize: 4 });
  }, [r == null ? void 0 : r.length, o]);
  return /* @__PURE__ */ e(I.div, { ref: u.setReference, children: /* @__PURE__ */ e(
    v,
    {
      isSmartData: t,
      isLoading: c,
      onRetry: f,
      variant: t && p ? "error" : void 0,
      disableFormik: !0,
      placeholder: "Search",
      rightAddon: l,
      error: i,
      ...s,
      onClear: m,
      onChange: (g) => d(g.target.value),
      value: r,
      ...a({
        ref: n
      })
    }
  ) });
});
export {
  w as LocationPickerInput
};
//# sourceMappingURL=LocationPicker.input.es.js.map
